/** Extract a user-facing message from a failed API response (Problem JSON or legacy shapes). */
const TECHNICAL_ERROR = /must not be (blank|null)|HTTP\s*\d+|constraint-violation|Field error/i;

export async function parseApiErrorMessage(
    response: Response,
    fallback = "Something went wrong. Please try again.",
): Promise<string> {
    try {
        const data = (await response.json()) as Record<string, unknown>;
        const detail = typeof data.detail === "string" ? data.detail : undefined;
        const message = typeof data.message === "string" ? data.message : undefined;
        const error = typeof data.error === "string" ? data.error : undefined;
        const text = detail || message || error;
        if (!text || TECHNICAL_ERROR.test(text)) {
            return fallback;
        }
        return text;
    } catch {
        return fallback;
    }
}
